"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicCourse = exports.getPublicCourses = exports.deleteCourseRelation = exports.postCourseRelation = exports.putCourseOrganization = exports.putCourseAccessibility = exports.deleteCoursePermission = exports.postCoursePermission = exports.putCourseAction = exports.postCourse = exports.putCourse = exports.getCourse = exports.getCourses = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var coursesAuthorizedPath = root_1.lmsAuthorized + '/courses/';
var coursesPublicPath = root_1.lmsPublic + '/courses/';

var getCourses = function getCourses(authentication, queryParameters) {
  return common_1.get(authentication, coursesAuthorizedPath, queryParameters);
};

exports.getCourses = getCourses;

var getCourse = function getCourse(authentication, id) {
  return common_1.get(authentication, coursesAuthorizedPath + id);
};

exports.getCourse = getCourse;

var putCourse = function putCourse(authentication, course) {
  return common_1.put(authentication, coursesAuthorizedPath + course.id, course);
};

exports.putCourse = putCourse;

var postCourse = function postCourse(authentication, course) {
  return common_1.post(authentication, coursesAuthorizedPath, course);
};

exports.postCourse = postCourse;

var putCourseAction = function putCourseAction(authentication, id, action, data) {
  return common_1.putSub(authentication, coursesAuthorizedPath, id, action, data);
};

exports.putCourseAction = putCourseAction;

var postCoursePermission = function postCoursePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, coursesAuthorizedPath, id, permission);
};

exports.postCoursePermission = postCoursePermission;

var deleteCoursePermission = function deleteCoursePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, coursesAuthorizedPath, id, permissionId);
};

exports.deleteCoursePermission = deleteCoursePermission;

var putCourseAccessibility = function putCourseAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, coursesAuthorizedPath, id, accessibility);
};

exports.putCourseAccessibility = putCourseAccessibility;

var putCourseOrganization = function putCourseOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, coursesAuthorizedPath, id, organizationId);
};

exports.putCourseOrganization = putCourseOrganization;

var postCourseRelation = function postCourseRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, coursesAuthorizedPath, id, relation);
};

exports.postCourseRelation = postCourseRelation;

var deleteCourseRelation = function deleteCourseRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, coursesAuthorizedPath, id, relationId);
};

exports.deleteCourseRelation = deleteCourseRelation;

var getPublicCourses = function getPublicCourses(authentication, queryParameters) {
  return common_1.get(authentication, coursesPublicPath, queryParameters);
};

exports.getPublicCourses = getPublicCourses;

var getPublicCourse = function getPublicCourse(authentication, id) {
  return common_1.get(authentication, coursesPublicPath + id);
};

exports.getPublicCourse = getPublicCourse;